<mat-card appearance="outlined"
  class="p-0">

  @if (cardTitle) {
    <mat-card-title>
      <div class="card-title-text">
        <div class="card-title-text__main">
          <ng-content select="[card-title-icon]"></ng-content>
          {{ cardTitle }}
        </div>
        <ng-content class="card-title-actions" select="[card-title-actions]"></ng-content>
      </div>
      @if (!hideDivider) {
        <mat-divider></mat-divider>
      }
    </mat-card-title>
  }

  <mat-card-content class="{{contentClass}}">
    <ng-content></ng-content>
  </mat-card-content>

</mat-card>
